"use strict";

import {findAll} from "../libs/@elements/dom-utils";
import formDataEntries from 'form-data-entries';

const INPUT_NAME_ATTR = 'q';

export function init() {
    const searchFormElems = findAll('.js-search-tracking');

    searchFormElems.forEach((searchFormElem) => {
        searchFormElem.addEventListener('submit', (e) => {
            const formData = getFormData(e.target);

            for (var pair of formData.entries()) {
                if (pair[0] === INPUT_NAME_ATTR) {
                    dataLayer.push({event: 'search', search: {
                        search_term: pair[1]
                    }});
                }
            }
        });
    });
}

function createFormData(forms) {
    let formData = new FormData();
    forms.map(form => {
        for (var pair of formDataEntries(form)) {
            formData.append(...pair);
        }
    });

    return formData;
}

function getFormData(form) {
    return createFormData([form]);
}
